import { render, staticRenderFns } from "./CourseDiscussPage.vue?vue&type=template&id=d27e6c82&scoped=true"
import script from "./CourseDiscussPage.vue?vue&type=script&lang=js"
export * from "./CourseDiscussPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e6c82",
  null
  
)

export default component.exports